import React from 'react';
import { ChevronRight, ScanText } from 'lucide-react';
import './AiAddPolicyCard.scss';

interface AiAddPolicyCardProps {
  title: string;
  description: string;
  orLabel: string;
  onClick: () => void;
}

/** A.I. add policy is an alternative to choosing a category manually. */
const AiAddPolicyCard = ({ title, description, orLabel, onClick }: AiAddPolicyCardProps) => {
  return (
    <div className="ai-add-policy">
      <div className="ai-add-policy__or">{orLabel}</div>
      <button type="button" className="ai-add-policy__card" onClick={onClick}>
        <span className="ai-add-policy__icon">
          <ScanText size={20} aria-hidden="true" />
        </span>
        <span className="ai-add-policy__copy">
          <span className="ai-add-policy__title">{title}</span>
          <span className="ai-add-policy__desc">{description}</span>
        </span>
        <ChevronRight className="ai-add-policy__go" size={20} aria-hidden="true" />
      </button>
    </div>
  );
};

export default AiAddPolicyCard;
